<template>
  <div class="dynamic-house-page">
    <!-- Start cyber Main Menu Area -->
    <div
      id="sticky-header"
      class="cyber_nav_manu d-md-none d-lg-block d-sm-none d-none"
    >
      <div class="container">
        <div class="row align-items-center">
          <div class="navbar-content">
            <div class="logo">
              <a class="logo_img" href="/" title="ipipbright">
                <img :src="require('../assets/images/ipipbright.png')" style="height: 73px;" alt="" />
              </a>
            </div>
            <nav class="cyber_menu">
              <ul class="nav_scroll">
                <li><router-link to="/" class="nav-link">{{ t.home }}</router-link></li>
                <li>
                  <router-link to="/" class="nav-link active">{{ t.services }}</router-link>
                  <ul class="sub-menu">
                    <li><router-link to="/dynamic">{{ t.serviceDynamic }}</router-link></li>
                  </ul>
                </li>
                <li><router-link to="/faq" class="nav-link">{{ t.tutorial }}</router-link>
                  <ul class="sub-menu">
                    <li><router-link to="/faq">{{ t.faq }}</router-link></li>
                  </ul>
                </li>
                <li>
                  <a href="javascript:void(0);" >{{ languageState.currentLanguage === 'en' ? 'English' : '简体中文' }}</a>
                  <ul class="sub-menu">
                    <li><a href="javascript:void(0);" @click="setLanguage('en')">English</a></li>
                    <li><a href="javascript:void(0);" @click="setLanguage('zh')">简体中文</a></li>
                  </ul>
                </li>
              </ul>
              <div class="auth-buttons">
                <router-link to="/login" class="auth-btn login-btn">{{ t.login }}</router-link>
                <router-link to="/register" class="auth-btn register-btn">{{ t.register }}</router-link>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile-menu-area d-sm-block d-md-block d-lg-none">
      <div class="mobile-menu-container">
        <div class="mobile-menu-header">
          <div class="mobile-menu-logo">
            <a href="/" title="ipipbright">
              <img :src="require('../assets/images/ipipbright.png')" style="height: 40px; margin: 10px 0 0 15px;" alt="ipipbright" />
            </a>
          </div>
          <a href="javascript:void(0);" class="mobile-menu-toggle" @click="toggleMobileMenu">
            <span></span>
            <span></span>
            <span></span>
          </a>
        </div>
        <div class="mobile-menu-body" v-show="isMobileMenuOpen">
          <ul class="mobile-menu-list">
            <li class="mobile-menu-item"><a href="javascript:void(0);" class="mobile-menu-link" @click="handleMobileNavClick('/')">{{ t.home }}</a></li>
            <li class="mobile-menu-item">
              <div class="mobile-menu-link-wrapper">
                <a href="#home" class="mobile-menu-link has-submenu" @click.stop="toggleDropdown($event, 'Package')">{{ t.services }}</a>
                <a href="javascript:void(0);" class="mobile-menu-expand" @click.stop="toggleDropdown($event, 'Package')">+</a>
              </div>
              <ul class="mobile-sub-menu" v-show="activeDropdown === 'Package'">
                <li class="mobile-sub-menu-item"><a href="javascript:void(0);" class="mobile-sub-menu-link" @click="handleMobileNavClick('/dynamic')">{{ t.serviceDynamic }}</a></li>
              </ul>
            </li>
            <li class="mobile-menu-item">
              <div class="mobile-menu-link-wrapper">
                <a href="/faq" class="mobile-menu-link has-submenu" @click.stop="toggleDropdown($event, 'Tutorial')">{{ t.tutorial }}</a>
                <a href="javascript:void(0);" class="mobile-menu-expand" @click.stop="toggleDropdown($event, 'Tutorial')">+</a>
              </div>
              <ul class="mobile-sub-menu" v-show="activeDropdown === 'Tutorial'">
                <li class="mobile-sub-menu-item"><a href="javascript:void(0);" class="mobile-sub-menu-link" @click="handleMobileNavClick('/faq')">{{ t.faq }}</a></li>
              </ul>
            </li>
            <li class="mobile-menu-item">
              <div class="mobile-menu-link-wrapper">
                <a href="#language" class="mobile-menu-link has-submenu" @click.stop="toggleDropdown($event, 'English')" >{{ languageState.currentLanguage === 'en' ? 'English' : '简体中文' }}</a>
                <a href="javascript:void(0);" class="mobile-menu-expand" @click.stop="toggleDropdown($event, 'English')">+</a>
              </div>
              <ul class="mobile-sub-menu" v-show="activeDropdown === 'English'">
                <li class="mobile-sub-menu-item"><a href="javascript:void(0);" class="mobile-sub-menu-link" @click="setLanguage('en')">English</a></li>
                <li class="mobile-sub-menu-item"><a href="javascript:void(0);" class="mobile-sub-menu-link" @click="setLanguage('zh')">简体中文</a></li>
              </ul>
            </li>
          </ul>
          <div class="mobile-auth-buttons">
            <a href="javascript:void(0);" class="mobile-auth-btn mobile-login-btn" @click="handleMobileNavClick('/login')">{{ t.login }}</a>
            <a href="javascript:void(0);" class="mobile-auth-btn mobile-register-btn" @click="handleMobileNavClick('/register')">{{ t.register }}</a>
          </div>
        </div>
      </div>
    </div>
    <!-- End cyber Main Menu Area -->

    <!-- Banner Section -->
    <section class="dynamic-banner-section ptb-100">
      <div class="container">
        <div class="banner-grid">
          <div class="banner-item content-item">
            <div class="banner-content">
              <h1>{{ t.serviceDynamic }}</h1>
              <p>{{ t.dynamicDesc }}</p>
              <a href="/login" class="default-btn">{{ t.learnMore }}</a>
            </div>
          </div>
          <div class="banner-item image-item">
            <div class="banner-image">
              <img :src="require('../assets/images/features2.png')" alt="Dynamic Residence" class="img-fluid">
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Banner Section -->

    <!-- Features Section -->
    <section id="features" class="features-section ptb-100 bg-light">
      <div class="container">
        <div class="section-title text-center">
          <h2>{{ t.featuresTitle }}</h2>
          <p>{{ t.featuresSubtitle }}</p>
        </div>
        <div class="features-grid">
          <div class="feature-item">
            <div class="feature-box">
              <div class="icon">
                <i class='bx bx-globe'></i>
              </div>
              <h3>{{ t.globalCoverage }}</h3>
              <p>{{ t.globalCoverageDesc }}</p>
            </div>
          </div>
          <div class="feature-item">
            <div class="feature-box">
              <div class="icon">
                <i class='bx bx-refresh'></i>
              </div>
              <h3>{{ t.autoRotation }}</h3>
              <p>{{ t.autoRotationDesc }}</p>
            </div>
          </div>
          <div class="feature-item">
            <div class="feature-box">
              <div class="icon">
                <i class='bx bx-shield-alt'></i>
              </div>
              <h3>{{ t.highTrust }}</h3>
              <p>{{ t.highTrustDesc }}</p>
            </div>
          </div>
          <div class="feature-item">
            <div class="feature-box">
              <div class="icon">
                <i class='bx bx-tachometer'></i>
              </div>
              <h3>{{ t.highSpeed }}</h3>
              <p>{{ t.highSpeedDesc }}</p>
            </div>
          </div>
          <div class="feature-item">
            <div class="feature-box">
              <div class="icon">
                <i class='bx bx-network-chart'></i>
              </div>
              <h3>{{ t.multiProtocol }}</h3>
              <p>{{ t.multiProtocolDesc }}</p>
            </div>
          </div>
          <div class="feature-item">
            <div class="feature-box">
              <div class="icon">
                <i class='bx bx-headphone'></i>
              </div>
              <h3>{{ t.technicalSupport }}</h3>
              <p>{{ t.technicalSupportDesc }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Features Section -->

    <!-- Benefits Section -->
    <section class="benefits-section ptb-100">
      <div class="container">
        <div class="benefits-grid">
          <div class="benefits-item image-item">
            <div class="benefits-image">
              <img :src="require('../assets/images/features1.png')" alt="Benefits" class="img-fluid">
            </div>
          </div>
          <div class="benefits-item content-item">
            <div class="benefits-content">
              <h2>{{ t.benefitsTitle }}</h2>
              <ul class="benefits-list">
                <li><i class='bx bxs-badge-check'></i>{{ t.benefit1 }}</li>
                <li><i class='bx bxs-badge-check'></i>{{ t.benefit2 }}</li>
                <li><i class='bx bxs-badge-check'></i>{{ t.benefit3 }}</li>
                <li><i class='bx bxs-badge-check'></i>{{ t.benefit4 }}</li>
                <li><i class='bx bxs-badge-check'></i>{{ t.benefit5 }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Benefits Section -->

    <!-- Pricing Section -->
    <section class="pricing-section ptb-100 bg-light">
      <div class="container">
        <div class="section-title text-center">
          <h2>{{ t.pricingTitle }}</h2>
          <p>{{ t.pricingSubtitle }}</p>
        </div>
        <div class="pricing-grid">
          <div class="pricing-item">
            <div class="pricing-plan">
              <div class="title">
                <div class="icon">
                  <i class='bx bx-data'></i>
                </div>
                <h3>{{ t.basicPlan }}</h3>
                <span>1GB</span>
              </div>
              <ul class="features">
                <li><i class='bx bxs-badge-check'></i>{{ t.premiumIPs }}</li>
                <li><i class='bx bxs-badge-check'></i>{{ t.rotatingIPs }}</li>
                <li><i class='bx bxs-badge-check'></i>{{ t.highTrustIPs }}</li>
                <li><i class='bx bxs-badge-check'></i>{{ t.unlimitedThreads }}</li>
              </ul>
              <div class="pricing-footer">
                <div class="price">
                  $6
                  <span>/month</span>
                </div>
                <a href="/login" class="default-btn">{{ t.getNow }}</a>
              </div>
            </div>
          </div>
          <div class="pricing-item">
            <div class="pricing-plan">
              <div class="title">
                <div class="icon">
                  <i class='bx bx-data'></i>
                </div>
                <h3>{{ t.standardPlan }}</h3>
                <span>10GB</span>
              </div>
              <ul class="features">
                <li><i class='bx bxs-badge-check'></i>{{ t.premiumIPs }}</li>
                <li><i class='bx bxs-badge-check'></i>{{ t.rotatingIPs }}</li>
                <li><i class='bx bxs-badge-check'></i>{{ t.highTrustIPs }}</li>
                <li><i class='bx bxs-badge-check'></i>{{ t.unlimitedThreads }}</li>
              </ul>
              <div class="pricing-footer">
                <div class="price">
                  $60
                  <span>/month</span>
                </div>
                <a href="/login" class="default-btn">{{ t.getNow }}</a>
              </div>
            </div>
          </div>
          <div class="pricing-item">
            <div class="pricing-plan">
              <div class="title">
                <div class="icon">
                  <i class='bx bx-data'></i>
                </div>
                <h3>{{ t.advancedPlan }}</h3>
                <span>50GB</span>
              </div>
              <ul class="features">
                <li><i class='bx bxs-badge-check'></i>{{ t.premiumIPs }}</li>
                <li><i class='bx bxs-badge-check'></i>{{ t.rotatingIPs }}</li>
                <li><i class='bx bxs-badge-check'></i>{{ t.highTrustIPs }}</li>
                <li><i class='bx bxs-badge-check'></i>{{ t.unlimitedThreads }}</li>
              </ul>
              <div class="pricing-footer">
                <div class="price">
                  $300
                  <span>/month</span>
                </div>
                <a href="/login" class="default-btn">{{ t.getNow }}</a>
              </div>
            </div>
          </div>
          <div class="pricing-item">
            <div class="pricing-plan">
              <div class="title">
                <div class="icon">
                  <i class='bx bx-data'></i>
                </div>
                <h3>{{ t.enterprisePlan }}</h3>
                <span>100GB</span>
              </div>
              <ul class="features">
                <li><i class='bx bxs-badge-check'></i>{{ t.premiumIPs }}</li>
                <li><i class='bx bxs-badge-check'></i>{{ t.rotatingIPs }}</li>
                <li><i class='bx bxs-badge-check'></i>{{ t.highTrustIPs }}</li>
                <li><i class='bx bxs-badge-check'></i>{{ t.unlimitedThreads }}</li>
              </ul>
              <div class="pricing-footer">
                <div class="price">
                  $600
                  <span>/month</span>
                </div>
                <a href="/login" class="default-btn">{{ t.getNow }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Pricing Section -->

    <!-- Footer Area -->
    <div class="footer-middle" id="footer">
      <div class="container">
        <div class="row">
          <!--footer widget 1 -->
          <div class="col-md-6 col-lg-3 col-xs-12">
            <div class="widget widgets_company_info">
              <h2 class="widget-title">IPIPBright</h2>
              <div class="company_info_desc">
                <p>
                  {{ t.footerDesc }}
                </p>
              </div>
              <div class="social_media">
                <h3>{{ t.followUs }}</h3>
                <a href="javascript:void(0);"><i class="fa-brands fa-facebook-f"></i></a>
                <a href="javascript:void(0);"><i class="fa-brands fa-linkedin-in"></i></a>
                <a href="javascript:void(0);"><i class="fa-brands fa-telegram"></i></a>
              </div>
            </div>
          </div>

          <!--footer widget 2 -->
          <div class="col-md-6 col-lg-3 col-xs-12">
            <div id="em_recent_post_widget-8" class="widget widget_recent_data">
              <div class="single-widget-item">
                <h2 class="widget-title">{{ t.quickLinks }}</h2>
                <div class="quick-link-item">
                  <div class="quick-post-text">
                    <h4>
                      <i class="fa fa-angle-right"></i
                      ><a href="/"> {{ t.home }} </a>
                    </h4>
                  </div>
                </div>
                <div class="quick-link-item">
                  <div class="quick-post-text">
                    <h4>
                      <i class="fa fa-angle-right"></i
                      ><a href="/privacy"> {{ t.privacyPolicy }} </a>
                    </h4>
                  </div>
                </div>
                <div class="quick-link-item">
                  <div class="quick-post-text">
                    <h4>
                      <i class="fa fa-angle-right"></i
                      ><a href="/service-policy"> {{ t.servicePolicy }} </a>
                    </h4>
                  </div>
                </div>
                <div class="quick-link-item">
                  <div class="quick-post-text">
                    <h4>
                      <i class="fa fa-angle-right"></i
                      ><a href="/faq"> {{ t.faq }} </a>
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--footer widget 3 -->
          <div class="col-md-6 col-lg-3 col-xs-12">
            <div id="em_recent_post_widget-7" class="widget widget_recent_data">
              <div class="single-widget-item">
                <h2 class="widget-title">{{ t.productServices }}</h2>
                <div class="quick-link-item">
                  <div class="quick-post-text">
                    <h4>
                      <i class="fa fa-angle-right"></i
                      ><a href="/dynamic"> {{ t.serviceDynamic }} </a>
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--footer widget 4 -->
          <div class="col-lg-3 col-md-6 col-xs-12 last">
            <div class="widget widget_get_quote">
              <h2 class="widget-title">{{ t.contactUs }}</h2>
              <div class="widget_get_quote_content">
                <div class="widget_quote_text">
                  <div class="footer_quote_text_decripsition">
                    <div class="footer_quote_decripsition_inner">
                      <p>
                        {{ t.supportText }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Footer Area -->
    
    <!-- Footer Bottom Area -->
    <div class="footer-bottom">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="footer-bottom-content">
              <p>{{ t.copyright }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Footer Bottom Area -->

    <!-- Simple go to top button -->
    <div 
      id="simple-go-top" 
      @click="scrollToTop"
      style="
        position: fixed;
        bottom: 30px;
        right: 30px;
        width: 55px;
        height: 55px;
        background: linear-gradient(135deg, #1581c6, #1581c6);
        color: white;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        z-index: 9999999;
        font-size: 26px;
        font-weight: bold;
        box-shadow: 0 8px 25px rgba(21, 129, 198, 0.6);
        transition: all 0.3s ease;
        opacity: 0;
        visibility: hidden;
        border: none;
      "
    >
      ↑
    </div>
  </div>
</template>

<script>
// import { mapState, mapMutations } from 'vuex'
// import { getField, updateField } from 'vuex-map-fields'
import '../assets/css/boxicons.min.css'
import '../assets/css/bootstrap.min.css'
import '../assets/css/owl.carousel.min.css'
import '../assets/css/owl.transitions.css'
import '../assets/css/animate.css'
import '../assets/fonts/font-awesome/css/font-awesome.min.css'
import '../assets/fonts/flaticon/font/flaticon.css'
import '../assets/css/theme-default.css'
import '../assets/css/meanmenu.min.css'
import '../assets/css/responsive.css'
import '../assets/css/widget.css'
import '../assets/css/style.css'
import '../assets/venobox/venobox.css'

export default {
  name: 'DynamicHouse',
  inject: ['changeLanguage', 'languageState'],
  data() {
    return {
      isSticky: false,
      isNavCollapsed: true,
      isMobileMenuOpen: false,
      activeDropdown: '',
      language: 'en',
      // 页面文本国际化配置
      i18n: {
        en: {
            home: 'Home',
            services: 'Package',
            serviceDynamic: 'Dynamic residence',
            serviceStatic: 'Static residence',
            blog: 'Tutorial Center',
            tutorial: 'Tutorial',
            faq: 'FAQs',
            signIn: 'Sign In',
            signUp: 'Sign Up',
            login: 'Login',
            register: 'Register',
            learnMore: 'Buy Now',
            dynamicDesc: 'High-quality dynamic residential IP proxy services to help you easily access global network resources while protecting your privacy and security.',
            featuresTitle: 'Key Features',
            featuresSubtitle: 'Discover the powerful features of our dynamic residential proxy services',
            globalCoverage: 'Global IP Coverage',
            globalCoverageDesc: 'Access to millions of residential IPs from over 170+ countries and regions',
            autoRotation: 'Automatic IP Rotation',
            autoRotationDesc: 'Automatically rotate IPs at intervals or on each request',
            highTrust: 'High Trust IPs',
            highTrustDesc: 'Avoid detection with IPs that have high trust scores',
            highSpeed: 'High Speed & Low Latency',
            highSpeedDesc: 'Fast and stable connections for optimal performance',
            multiProtocol: 'Multi-Protocol Support',
            multiProtocolDesc: 'Supports HTTP, HTTPS, and SOCKS5 protocols',
            technicalSupport: '24/7 Technical Support',
            technicalSupportDesc: 'Professional support team available around the clock',
            benefitsTitle: 'Why Choose Our Dynamic Residential Proxies?',
            benefit1: 'Access geo-restricted content',
            benefit2: 'Bypass IP bans and restrictions',
            benefit3: 'Protect your online privacy',
            benefit4: 'Ideal for web scraping and data mining',
            benefit5: 'Suitable for ad verification and market research',
            pricingTitle: 'Flexible Pricing Plans',
            pricingSubtitle: 'Choose the perfect plan for your needs',
            basicPlan: 'BASIC',
            standardPlan: 'STANDARD',
            advancedPlan: 'ADVANCED',
            enterprisePlan: 'ENTERPRISE',
            premiumIPs: 'Premium Residential IPs',
            rotatingIPs: 'Rotating IPs',
            rotatingSticky: 'Rotating & Sticky IPs',
            highTrustIPs: 'High Trust IPs',
            unlimitedThreads: 'Unlimited Threads',
            getNow: 'Get Now',
            footerDesc: 'Your trusted partner for high-quality proxy services with global coverage and exceptional performance.',
            quickLinks: 'Quick Links',
            residentialProxies: 'Residential Proxies',
            mobileProxies: 'Mobile Proxies',
            datacenterProxies: 'Datacenter Proxies',
            rotatingProxies: 'Rotating Proxies',
            contactUs: 'Contact Us',
            address: '123 Proxy Street, Suite 456, Proxy City, PC 12345',
            phone: '+1 (123) 456-7890',
            email: 'info@ipipbright.com',
            copyright: 'ipipbright. © 2024 All Rights Reserved.',
            privacyPolicy: 'Privacy Policy',
            servicePolicy: 'Service Policy',
            termsOfService: 'Terms of Service',
            contactInfo: 'Contact Info',
            usefulLinks: 'Useful Links',
            support: 'Support',
            welcomeMessage: 'Welcome to try our products!',
            followUs: 'Follow Us',
            productServices: 'Product Services',
            supportText: '24/7 technical support, ready to answer your questions and provide professional IP proxy solutions.'
          },
          zh: {
            home: '首页',
            services: '动态套餐',
            serviceDynamic: '动态住宅',
            serviceStatic: '静态住宅',
            blog: '教程中心',
            tutorial: '教程中心',
            faq: '常见问题',
            signIn: '登录',
            signUp: '注册',
            login: '登录',
            register: '注册',
            learnMore: '立即购买',
            dynamicDesc: '高质量的动态住宅IP代理服务，帮助您轻松访问全球网络资源，同时保护您的隐私和安全。',
            featuresTitle: '核心功能',
            featuresSubtitle: '探索我们动态住宅代理服务的强大功能',
            globalCoverage: '全球IP覆盖',
            globalCoverageDesc: '访问来自170多个国家和地区的数百万住宅IP',
            autoRotation: '自动IP轮换',
            autoRotationDesc: '按时间间隔或每次请求自动轮换IP',
            highTrust: '高信任IP',
            highTrustDesc: '使用具有高信任评分的IP避免检测',
            highSpeed: '高速低延迟',
            highSpeedDesc: '快速稳定的连接，提供最佳性能',
            multiProtocol: '多协议支持',
            multiProtocolDesc: '支持HTTP、HTTPS和SOCKS5协议',
            technicalSupport: '24/7技术支持',
            technicalSupportDesc: '专业支持团队全天候为您服务',
            benefitsTitle: '为什么选择我们的动态住宅代理？',
            benefit1: '访问地理限制内容',
            benefit2: '绕过IP禁令和限制',
            benefit3: '保护您的在线隐私',
            benefit4: '理想的网页抓取和数据挖掘工具',
            benefit5: '适合广告验证和市场研究',
            pricingTitle: '灵活的定价计划',
            pricingSubtitle: '选择适合您需求的完美计划',
            basicPlan: '基础版',
            standardPlan: '标准版',
            advancedPlan: '高级版',
            enterprisePlan: '企业版',
            premiumIPs: '优质住宅IP',
            rotatingIPs: '动态IP',
            rotatingSticky: '动态&静态IP',
            highTrustIPs: '高信任IP',
            unlimitedThreads: '无限线程',
            getNow: '立即购买',
            footerDesc: '您值得信赖的高质量代理服务合作伙伴，提供全球覆盖和卓越性能。',
            quickLinks: '快速链接',
            residentialProxies: '住宅代理',
            mobileProxies: '移动代理',
            datacenterProxies: '数据中心代理',
            rotatingProxies: '动态代理',
            contactUs: '联系我们',
            address: '代理街123号，456室，代理城，PC 12345',
            phone: '+1 (123) 456-7890',
            email: 'info@ipipbright.com',
            copyright: 'ipipbright. © 2024 保留所有权利。',
            privacyPolicy: '隐私政策',
            servicePolicy: '服务政策',
            termsOfService: '服务条款',
            contactInfo: '联系信息',
            usefulLinks: '有用链接',
            support: '支持',
            welcomeMessage: '欢迎试用我们的产品！',
            followUs: '关注我们',
            productServices: '产品服务',
            supportText: '24/7技术支持，随时为您解答问题，提供专业的IP代理解决方案。'
          }
      }
    }
  },
  computed: {
    // 获取当前语言的文本
    t() {
      const lang = this.languageState.currentLanguage;
      return this.i18n[lang] || this.i18n.en;
    }
  },
  methods: {
    // 设置语言
    setLanguage(lang) {
      this.changeLanguage(lang);
      this.activeDropdown = '';
    },
    // 切换移动端菜单
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    },
    // 处理移动端导航链接点击
    handleMobileNavClick(targetRoute) {
      // 检查是否为当前路由，避免重复导航错误
      if (this.$route.path !== targetRoute) {
        this.$router.push(targetRoute);
      }
      // 无论是否导航，都关闭菜单
      this.isMobileMenuOpen = false;
      this.activeDropdown = '';
    },
    // 切换下拉菜单
    toggleDropdown(event, dropdownName) {
      event.preventDefault();
      if (this.activeDropdown === dropdownName) {
        this.activeDropdown = '';
      } else {
        this.activeDropdown = dropdownName;
      }
    },
    // 滚动到指定部分
    scrollToSection(sectionId) {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    },
    // 滚动到顶部
    scrollToTop() {
      console.log('scrollToTop called');
      
      // 方法1：使用window.location.href直接跳转到页面顶部
      try {
        window.location.href = '#';
      } catch (e) {
        console.error('Method 1 failed:', e);
      }
      
      // 方法2：使用document.documentElement.scrollIntoView
      try {
        document.documentElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } catch (e) {
        console.error('Method 2 failed:', e);
      }
      
      // 方法3：使用document.body.scrollIntoView
      try {
        document.body.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } catch (e) {
        console.error('Method 3 failed:', e);
      }
      
      // 方法4：直接设置scrollTop为0
      try {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      } catch (e) {
        console.error('Method 4 failed:', e);
      }
      
      // 方法5：查找所有可能的滚动容器并设置scrollTop为0
      try {
        const scrollableElements = document.querySelectorAll('div, section, main, body, html');
        scrollableElements.forEach(el => {
          if (el.scrollTop > 0) {
            el.scrollTop = 0;
          }
        });
      } catch (e) {
        console.error('Method 5 failed:', e);
      }
    }
  },
  mounted() {
    // 使用requestAnimationFrame定期检查滚动位置
    const checkScrollPosition = () => {
      // 同时检查window.scrollY和document.documentElement.scrollTop，确保在不同浏览器中都能获取到正确的滚动位置
      const scrollY = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop
      const goTopBtn = document.getElementById('simple-go-top')
      if (goTopBtn) {
        if (scrollY > 300) {
          goTopBtn.style.opacity = '1'
          goTopBtn.style.visibility = 'visible'
        } else {
          goTopBtn.style.opacity = '0'
          goTopBtn.style.visibility = 'hidden'
        }
      }
      // 更新isSticky状态
      this.isSticky = scrollY > 50
      
      // 继续下一帧检查
      this.animationFrameId = requestAnimationFrame(checkScrollPosition)
    }
    
    // 启动requestAnimationFrame循环
    this.animationFrameId = requestAnimationFrame(checkScrollPosition)
  },
  beforeDestroy() {
    // 取消requestAnimationFrame循环
    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId)
    }
  }
}
</script>

<style scoped>
/* CSS Variables */
:root {
  --fontFamily: 'Nunito', sans-serif;
  --mainColor: #4146E6;
  --optionalColor: #6F8BA4;
  --whiteColor: #ffffff;
  --blackColor: #3B566E;
  --fontSize: 16px;
  --transition: .5s;
}

/* Default Button Styles */
.default-btn {
  display: inline-block;
  border: none;
  box-shadow: 0;
  transition: var(--transition);
  text-decoration: none;
  background-color: #ffffff;
  color: #1581c6;
  padding: 12px 35px;
  position: relative;
  z-index: 1;
  border-radius: 5px;
  font-size: 15px;
  font-weight: 700;
}

.default-btn:hover {
  color: #ffffff;
  border-color: transparent;
  border: 0;
}

.default-btn:hover::before {
  opacity: 1;
  visibility: visible;
  width: 100%;
}

.default-btn::before {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: -1;
  opacity: 0;
  visibility: hidden;
  border-radius: 5px;
  transition: var(--transition);
  background: #1581c6;
  width: 0%;
  height: 100%;
}

/* Global Text Color */
h1, h2, h3, h4, h5, h6, p, li {
  color: white !important;
}

/* Background Color for Divs */
.slider_area,
.feature_area,
.service_area,
.country_ip_area,
.feature_box_area,
.pricing_area {
  background-color: #2d2c28 !important;
}

/* Single Feature Styles */
.single_feature {
  background-color: #2d2c28 !important;
}

.single_feature_content_inner h2 {
  color: white;
}

.single_feature_content_inner p {
  color: white;
}

/* Single Service Styles */
.single_service {
  background-color: #2d2c28 !important;
}

.single_service_content h4 {
  color: white;
}

/* Country IP Card Styles */
.country_ip_card {
  background-color: #2d2c28 !important;
  border: 1px solid #3d3c38 !important;
}

.country_name {
  color: white;
}

.ip_count {
  color: white;
}

/* Single Feature Box Styles */
.single_feature_box {
  background-color: #2d2c28 !important;
}

.single_feature_box_content h2 {
  color: white;
}

.single_feature_box_content_text p {
  color: white;
}

/* Single Pricing Styles */
.single_pricing {
  background-color: #2d2c28 !important;
}

.pricing_title h3 {
  color: white;
}

.pricing_tk h2 {
  color: white;
}

.pricing_tk h2 span {
  color: white;
}

.featur li {
  color: white;
}

/* Section Title Styles */
.section_title_inner h2 {
  color: white;
}

.section_title_text p {
  color: white;
}

/* Container Styles */
.container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container {
    max-width: 540px;
  }
}

@media (min-width: 768px) {
  .container {
    max-width: 720px;
  }
}

@media (min-width: 992px) {
  .container {
    max-width: 960px;
  }
}

@media (min-width: 1200px) {
  .container {
    max-width: 1140px;
  }
}

/* Padding Styles */
.ptb-100 {
  padding-top: 100px;
  padding-bottom: 100px;
}

.pt-100 {
  padding-top: 100px;
}

.pb-100 {
  padding-bottom: 100px;
}

.pb-70 {
  padding-bottom: 70px;
}

/* Background Styles */
.bg-light {
  background-color: #2d2c28 !important;
}

/* Section Title Styles */
.section-title {
  text-align: center;
  max-width: 720px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 50px;
}

.section-title h2 {
  font-size: 25px;
  margin-bottom: 12px;
}

.section-title p {
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}
/* Mobile Menu Button Styles */
@media (max-width: 991px) {
  .template-responsive-navbar .others-option {
    display: flex !important;
    flex-direction: column;
    gap: 10px;
    margin-top: 20px;
    position: static;
  }
  .template-responsive-navbar .others-option .item {
    margin-left: 0;
    width: 100%;
  }
  .template-responsive-navbar .others-option .item:first-child {
    margin-left: 0;
  }
  .template-responsive-navbar .others-option .default-btn {
    width: 100%;
    text-align: center;
    padding: 14px 35px;
    font-size: 16px;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
  .template-responsive-navbar .others-option .item:nth-child(1) .default-btn {
    background-color: var(--whiteColor);
    color: var(--mainColor);
    border: 2px solid var(--mainColor);
  }
  .template-responsive-navbar .others-option .item:nth-child(1) .default-btn::before {
    background: linear-gradient(135deg, var(--mainColor) 0%, var(--secondaryColor) 100%);
  }
  .template-responsive-navbar .others-option .item:nth-child(2) .default-btn {
    background-color: var(--mainColor);
    color: var(--whiteColor);
  }
  .template-responsive-navbar .others-option .item:nth-child(2) .default-btn::before {
    background: linear-gradient(135deg, var(--secondaryColor) 0%, var(--mainColor) 100%);
  }
}
/* Mobile menu styles */
.mobile-menu-area {
  background: #fff;
}

.mobile-menu-container {
  position: relative;
}

.mobile-menu-header {
  background: #32312d;
  min-height: 60px;
  padding: 4px 0 0;
  position: relative;
  width: 100%;
  z-index: 999999;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.mobile-menu-logo {
  flex: 1;
}

.mobile-menu-toggle {
  width: 40px;
  height: 40px;
  padding: 10px;
  cursor: pointer;
  color: #fff;
  text-decoration: none;
  font-size: 16px;
  line-height: 20px;
  font-weight: 700;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  margin-right: 15px;
  /* background: rgba(255, 255, 255, 0.1); */
  border-radius: 4px;
}

.mobile-menu-toggle span {
  display: block;
  background: #fff;
  height: 3px;
  width: 24px;
  margin: 2px 0;
  transition: all 0.3s ease;
}

.mobile-menu-body {
  background: #fff;
  border: 1px solid #eaeaea;
  border-top: none;
}

.mobile-menu-list {
  padding: 0;
  margin: 0;
  list-style-type: none;
  background: #fff;
}

.mobile-menu-item {
  border-top: 1px solid #ddd;
}

.mobile-menu-item:first-child {
  border-top: none;
}

.mobile-menu-link-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.mobile-menu-link {
  display: block;
  padding: 1em 5%;
  color: #444;
  font-size: 14px;
  font-weight: bold;
  text-decoration: none;
  text-transform: uppercase;
  flex: 1;
}

.mobile-menu-link:hover {
  color: #1581c6;
}

.mobile-menu-expand {
  display: block;
  padding: 1em;
  color: #444;
  font-size: 14px;
  font-weight: bold;
  text-decoration: none;
  background: transparent;
  border: none;
  cursor: pointer;
}

.mobile-menu-expand:hover {
  color: #1581c6;
}

.mobile-sub-menu {
  padding: 0;
  margin: 0;
  list-style-type: none;
  background: #f8f8f8;
}

.mobile-sub-menu-item {
  border-top: 1px solid #eaeaea;
}

.mobile-sub-menu-link {
  display: block;
  padding: 0.8em 10%;
  color: #151948;
  font-size: 13px;
  font-weight: normal;
  text-decoration: none;
  text-transform: capitalize;
}

.mobile-sub-menu-link:hover {
  color: #1581c6;
}

@media (min-width: 1200px) {
  .container {
      max-width: 1400px !important;
  }
}
</style>

<style scoped>
/* Desktop menu sticky styles */
#sticky-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  background: #32312d;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  width: auto;
}

/* Mobile menu container */
.mobile-menu-container {
  position: relative;
  z-index: 99999;
}

/* Mobile menu header sticky styles */
.mobile-menu-header {
  position: fixed !important;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 99999;
}

/* Mobile menu body should be fixed to viewport */
.mobile-menu-body {
  position: fixed !important;
  top: 60px;
  left: 0;
  right: 0;
  /* Make menu height smaller than full viewport */
  max-height: 70vh;
  margin-top: 0;
  z-index: 99998;
  overflow-y: auto;
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(10px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
}

/* Make menu list background transparent */
.mobile-menu-list {
  background: transparent !important;
}

/* Make menu items background transparent */
.mobile-menu-item {
  background: transparent !important;
}

/* Adjust menu link styles */
.mobile-menu-link {
  /* background: transparent !important; */
  color: #fff !important;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
}

.mobile-menu-link:hover {
  color: #ccc !important;
}

.mobile-menu-expand {
  color: #fff !important;
}

.mobile-sub-menu {
  background: rgba(0, 0, 0, 0.7) !important;
}

.mobile-sub-menu-link {
  color: #fff !important;
}

.mobile-sub-menu-link:hover {
  color: #ccc !important;
}

.mobile-auth-btn {
  color: #fff !important;
  background: rgba(255, 255, 255, 0.2) !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
}

.mobile-auth-btn:hover {
  background: rgba(255, 255, 255, 0.3) !important;
  color: #fff !important;
}

.dynamic-banner-section {
  background-color: #2d2c28;
  margin-top: 100px;
}

/* Remove margin-top on mobile */
@media (max-width: 768px) {
  .dynamic-banner-section {
    margin-top: 0;
  }
}

/* Banner Grid Styles */
.banner-grid {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}

.banner-item {
  flex: 0 0 calc(50% - 20px);
  max-width: calc(50% - 20px);
}

/* Features Grid Styles */
.features-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.feature-item {
  flex: 0 0 calc(33.333% - 20px);
  max-width: calc(33.333% - 20px);
}

.benefits-section {
  background-color: #2d2c28 !important;
}

/* Benefits Grid Styles */
.benefits-grid {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}

.benefits-item {
  flex: 0 0 calc(50% - 20px);
  max-width: calc(50% - 20px);
}

/* Banner Content Styles */
.banner-content h1 {
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 20px;
  color: #2c3e50;
}

.banner-content p {
  font-size: 1.125rem;
  margin-bottom: 30px;
  color: #666;
  line-height: 1.6;
}

/* Image Styles */
.img-fluid {
  max-width: 100%;
  height: auto;
}

/* Responsive Design for Grids */
@media (max-width: 992px) {
  .banner-item,
  .benefits-item {
    flex: 0 0 100%;
    max-width: 100%;
  }
  
  .feature-item {
    flex: 0 0 calc(50% - 20px);
    max-width: calc(50% - 20px);
  }
}

@media (max-width: 768px) {
  .feature-item {
    flex: 0 0 100%;
    max-width: 100%;
  }
}

.section-title {
  margin-bottom: 50px;
}

.section-title h2 {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 15px;
  color: #2c3e50;
}

.section-title p {
  font-size: 1.125rem;
  color: #666;
  max-width: 700px;
  margin: 0 auto;
}

.feature-box {
  background: #2d2c28 !important;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  margin-bottom: 30px;
}

.feature-box:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
}

.feature-box .icon {
  width: 60px;
  height: 60px;
  background: #007bff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  color: #fff;
  font-size: 1.5rem;
}

.feature-box h3 {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 15px;
  color: #2c3e50;
}

.feature-box p {
  color: #666;
  line-height: 1.6;
}

.benefits-content h2 {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 25px;
  color: #2c3e50;
}

.benefits-list {
  list-style: none;
  padding: 0;
}

.benefits-list li {
  padding: 10px 0;
  color: #666;
  font-size: 1.125rem;
  display: flex;
  align-items: center;
}

.benefits-list li i {
  color: #007bff;
  margin-right: 15px;
  font-size: 1.25rem;
}

.pricing-grid {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
}

.pricing-item {
  flex: 0 0 calc(25% - 20px);
  max-width: calc(25% - 20px);
  margin-top: 0;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .pricing-item {
    flex: 0 0 calc(33.333% - 20px);
    max-width: calc(33.333% - 20px);
  }
}

@media (max-width: 992px) {
  .pricing-item {
    flex: 0 0 calc(50% - 20px);
    max-width: calc(50% - 20px);
  }
}

@media (max-width: 768px) {
  .pricing-item {
    flex: 0 0 100%;
    max-width: 100%;
  }
}

.pricing-plan {
  background: #2d2c28 !important;
  border-radius: 10px;
  padding: 30px;
  text-align: center;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  margin-bottom: 30px;
  width: 100%;
  box-sizing: border-box;
  display: block;
  opacity: 1;
  visibility: visible;
}



.pricing-plan .title {
  margin-bottom: 30px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.pricing-plan .icon {
  width: 60px;
  height: 60px;
  background: #007bff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  /* margin: 0 auto 20px; */
  color: #fff;
  font-size: 1.5rem;
}

.pricing-plan h3 {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 10px;
  color: #2c3e50;
  text-align: center;
}

.pricing-plan span {
  color: #666;
  font-size: 1rem;
  text-align: center;
}

.pricing-plan .features {
  list-style: none;
  padding: 0;
  margin-bottom: 30px;
}

.pricing-plan .features li {
  padding: 10px 0;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pricing-plan .features li i {
  color: #28a745;
  margin-right: 10px;
}

.pricing-plan .pricing-footer {
  text-align: center;
}

.pricing-plan .price {
  font-size: 2.5rem;
  font-weight: 700;
  color: #007bff;
  margin-bottom: 20px;
  text-align: center;
}

.pricing-plan .price span {
  font-size: 1rem;
  color: #666;
  font-weight: normal;
  text-align: center;
}

.footer-section {
  background: #3B566E;
  color: #fff;
  padding: 100px 0 0;
}

.footer-widget {
  margin-bottom: 30px;
}

.footer-widget h3 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #fff;
}

.footer-widget.pl-4 {
  padding-left: 0;
}

.footer-contact-info {
  list-style: none;
  padding: 0;
}

.footer-contact-info li {
  margin-bottom: 15px;
  color: #ddd;
  line-height: 1.6;
}

.footer-contact-info a {
  color: #ddd;
  text-decoration: none;
  transition: all 0.3s ease;
}

.footer-contact-info a:hover {
  color: #007bff;
}

.links-list {
  list-style: none;
  padding: 0;
}

.links-list li {
  margin-bottom: 15px;
}

.links-list a {
  color: #ddd;
  text-decoration: none;
  transition: all 0.3s ease;
  padding: 4px;
  display: block;
}

.links-list a:hover {
  color: #007bff;
  padding-left: 5px;
}

.logo {
  display: inline-block;
  /* margin-bottom: 20px; */
}

.logo a {
  color: #fff;
  font-size: 24px;
  font-weight: 700;
  text-decoration: none;
}

.logo-text {
  color: #fff;
}

.social-links {
  list-style: none;
  padding: 0;
  display: flex;
  margin-top: 20px;
}

.social-links li {
  margin-right: 15px;
}

.social-links a {
  color: #fff;
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  transition: all 0.3s ease;
}

.social-links a:hover {
  background: #007bff;
  transform: translateY(-3px);
}

.footer-widget p {
  color: #ddd;
  line-height: 1.6;
  margin-bottom: 20px;
}

.copyright-area {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding: 20px 0;
  margin-top: 30px;
}

.copyright-area p {
  color: #ddd;
  margin: 0;
  text-align: center;
}

.go-top {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 40px;
  height: 40px;
  background: #007bff;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  z-index: 999;
}

.go-top.active {
  opacity: 1;
  visibility: visible;
}

.go-top:hover {
  background: #0056b3;
  transform: translateY(-3px);
}

/* Hide browser scrollbars globally */
* {
  scrollbar-width: none;
  -ms-overflow-style: none;
}

*::-webkit-scrollbar {
  display: none;
}

</style>